import { render, staticRenderFns } from "./Choice.vue?vue&type=template&id=4e5bfc24&scoped=true&"
import script from "./Choice.vue?vue&type=script&lang=ts&"
export * from "./Choice.vue?vue&type=script&lang=ts&"
import style0 from "./Choice.vue?vue&type=style&index=0&id=4e5bfc24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5bfc24",
  null
  
)

export default component.exports